import { environment } from '../../environments/environment';
import { IList } from '../contentmanagement/contentmanagement.list';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, HttpParams } from '@angular/common/http';
import { Observable, throwError  } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
// import { error } from 'console';
// import { resolve4 } from 'dns';


@Injectable()
export class ContentmanagementService {

  headers: any;
  options: any;

  constructor(private http: HttpClient) {
    const headersItem = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.headers = headersItem;
    this.options = {headers: this.headers};
  }


  getContentlist() {
    console.log("getContentlist")
    return this.http.get(environment.restAPI + 'contents', this.options)
    .pipe(
      map((res: any) => res ),
      tap(data => data),
      catchError(this.handleError)
    );
  }

  getSources() {
    console.log("getSources")
    return this.http.get(environment.restAPI + 'sources', this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }
  

  getSubject() {
    console.log("getSubject")
    return this.http.get(environment.restAPI + 'subjects', this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getProjectSubject(projectId) {
    console.log("getProjectSubject")
    return this.http.get(environment.restAPI + 'project/' + projectId, this.options)
      .pipe(
        map((res: any) => res[0].subjects),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getYear() {
    return this.http.get(environment.restAPI + 'years', this.options)
    .pipe(
      map((res: any) => res),
      tap(data => data),
      catchError(this.handleError)
    );

  }

  getGrade() {
    return this.http.get(environment.restAPI + 'grades', this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );

  }

  getProjectGrade(projectId) {
    return this.http.get(environment.restAPI + 'project/' + projectId, this.options)
      .pipe(
        map((res: any) => res[0].grades),
        tap(data => data),
        catchError(this.handleError)
      );

  }


  addNewTopic(topic) {
    return this.http.post(environment.restAPI + 'topic', topic, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getTopics(subjectId) {
    return this.http.get(environment.restAPI + 'topics/subject/' + subjectId, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getLanguage() {
    return this.http.get(environment.restAPI + 'languages', this.options)
    .pipe(
      map((res: any) => res),
      tap(data => data),
      catchError(this.handleError)
    );

  }


  getMediaType() {
    console.log("getMediaType")
    return this.http.get(environment.restAPI + 'types', this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }


  getProjects() {
    return this.http.get(environment.restAPI + 'projects', this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getProjectContentList(projectId) {
    return this.http.get(environment.restAPI + 'contents/project/' + projectId, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  deleteContent(contentId) {
    return this.http.delete(environment.restAPI + 'content/' + contentId, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }


  createNewContent(data) {
    return this.http.post(environment.restAPI + 'content', data, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  contentDetails(contentId) {
    return this.http.get(environment.restAPI + 'content/' + contentId, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  updateContent(contentId, data) {
    return this.http.put(environment.restAPI + 'content/' + contentId, data, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );

  }

  // classroom service
  getClassRoomListData() {
    return this.http.get(environment.restAPI + 'classrooms', this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getClassStudentListData(classID) {
    return this.http.get(environment.restAPI + 'students/class/' + classID, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getClassGroupListData(classID) {
    return this.http.get(environment.restAPI + 'groups/class/' + classID, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  createGroup(data) {
    return this.http.post(environment.restAPI + 'group', data, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  updateGroup(groupId, data) {
    return this.http.put(environment.restAPI + 'group/' + groupId, data, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  deleteGroup(groupId) {
    return this.http.delete(environment.restAPI + 'group/' + groupId, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  // distribute service
  distributeContentService(data, courseId) {
    return this.http.put(environment.restAPI + 'distribute/content/' + courseId, data, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }


  distributedMaterialGroupClassList(courseId) {
    return this.http.get(environment.restAPI + 'classgroups/content/' + courseId, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getDestributedMaterialListData() {
    return this.http.get(environment.restAPI + 'distributed/contents?classlist=true', this.options)
      .pipe(
        map((res: any) => res),
        tap(data => JSON.stringify(data)),
        catchError(this.handleError)
      );
  }


  getClassMaterialListData(classId) {
    return this.http.get(environment.restAPI + 'distributed/contents?class_id=' + classId, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getGroupMaterialListData(groupId) {
    return this.http.get(environment.restAPI + 'distributed/contents?group_id' + groupId, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getDistributeMaterialListByGroupID(groupId) {
    return this.http.get(environment.restAPI + 'distributed/contents?group_id=' + groupId, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  getMyCreatedListData() {
    return this.http.get(environment.restAPI + 'mycontents ', this.options)
      .pipe(
        map((res: any) => res),
        tap(data => JSON.stringify(data)),
        catchError(this.handleError)
      );
  }

  // curriculum
  addContentToUnit(addContentToUnit, contentId) {
    const cdata: any = {};
    cdata.content_id = contentId;
    return this.http.put(
      environment.restAPI + 'curriculum/' + addContentToUnit.curriculum_id + '/year/' + addContentToUnit.year_id + '/topic/' + addContentToUnit.topic_id + '/unit/' + addContentToUnit.unit_id, cdata, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );
  }

  setFavorite(contentId, data) {
    return this.http.put(environment.restAPI + 'favorite/' + contentId, data, this.options)
      .pipe(
        map((res: any) => res),
        tap(data => data),
        catchError(this.handleError)
      );

  }

  handleError(error: Response) {
    return throwError(error);
  }
}
